import React, { useEffect } from "react";
import AboutUs from "../../assets/images/about.png";
import { Link } from "react-router-dom";
import "./Home.css";
import AOS from "aos";
import "aos/dist/aos.css";
import Bg from "../../assets/images/slide1.jpg";
import Ex1 from "../../assets/images/ex1.png";
import Ex2 from "../../assets/images/ex2.png";
import Ex3 from "../../assets/images/ex3.png";
import Ex5 from "../../assets/images/ex5.png";
import Ex8 from "../../assets/images/ex8.png";
import ab from "../../assets/images/abbg.png";

import OurClients from "../OurClients/OurClients";
import HeroSection from "./HeroSection";
import ServicesOffer from "./ServicesOffer";
import WhyChooes from "./WhyChooes";
import OurServices from "../Website/OurServices";
import Casestudy from "../CaseStudy/Casestudy";
import AllBlogCard from "../Blog/AllBlogCard";

function Home() {
  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration
      once: true, // Whether animation should only happen once
    });
  }, []);

  const industries = [
    {
      id: 1,
      imgSrc: Ex1,
      title: "Interactive Voice Response",
      description:
        "We provide the service called IVR—an automated telephony system technology...",
      path: "/interactive-voice-response",
    },
    {
      id: 2,
      imgSrc: Ex2,
      title: "Lead Management System",
      description:
        "We provide services to manage a solid lead management system which ensures...",
      path: "/leads-management-system",
    },
    {
      id: 3,
      imgSrc: Ex3,
      title: "Missed Call Alert Services",
      description:
        "Stay in touch even in poor networks with our missed call alert services...",
      path: "/missed-call-alert-services",
    },
    {
      id: 4,
      imgSrc: Ex5,
      title: "Customer Relationship",
      description:
        "Customer Relationship involves systems and processes to improve client engagement...",
      path: "/customer-relationship",
    },
    {
      id: 5,
      imgSrc: Ex8,
      title: "Employee Tracking System",
      description:
        "Simplify tracking — monitor performance, manage attendance, assign tasks, boost productivity.",
      path: "/employee-tracking-system",
    },
  ];
  return (
    <>
      <div>
        <HeroSection />
      </div>
      <div>
        {/* Features Section */}
        <ServicesOffer />
      </div>
      {/* about trail */}
      <div
        className="bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${ab})` }}
      >
        <div className="container-wrapper py-10 px-5 bg-white/60 backdrop-blur-sm z-0">
          <div className="text-center mx-auto pb-3" data-aos="fade-down">
            <div>
              <span className="text-[#BC4242] bg-[#f5decd] rounded-md px-3 py-1 text-xs">
                About us Deetya Soft
              </span>
            </div>
            <h2 className="text-xl md:text-3xl text-heading font-semibold">
              About US
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-10 items-center">
            {/* Image Section */}
            <div className="flex justify-center" data-aos="zoom-in">
              <img
                src={AboutUs}
                alt="Tablet Mockup"
                width={500}
                height={500}
                className="object-contain w-full max-w-[500px] mx-auto mb-4 md:mb-0"
              />
            </div>

            {/* Text Section */}
            <div
              className="flex flex-col justify-center text-[14px] md:text-base"
              data-aos="fade-up"
            >
              <p className="mb-2">
                Deetya Soft is an IT solution provider for varied services in
                application development, website designing, mobile application
                development campaigning solutions and SU solutions.
              </p>
              <p className="mb-2">
                Our team of experts works closely with the clients to create
                customised IVR solution tailored to specific industry
                requirements. Our next generation IVR Solution suitable to all
                business sectors from small business to large enterprises i.e
                real estate, Telecom, schools, hospitals, healthcare, commercial
                product organizations and management firms. Our flexible IVR
                solution scales with the growth of business, provide 24*7
                support, real-time analytics that enhance ultimate
                customer satisfaction.
              </p>

              <div className="mt-2" data-aos="fade-up">
                <Link
                  to="/about-us"
                  className="inline-flex no-underline items-center gap-2 bg-orangeheading text-white font-semibold px-4 py-2 rounded-full shadow-md border-2 border-orangeheading transition-all duration-300 group hover:bg-transparent hover:text-orangeheading hover:shadow-lg"
                >
                  Read More
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <WhyChooes />
      {/* services */}
      <OurServices />
      {/* about  Industries */}
      <div
        className="relative py-20 text-white bg-fixed bg-cover bg-center"
        style={{ backgroundImage: `url(${Bg})` }}
      >
        <div className="container mx-auto px-4 text-center">
          <div>
            <h3 className="md:text-4xl text-2xl text-white font-semibold">
              Expertise Industries
            </h3>
            <div className=" md:w-32 w-20   h-1 bg-main1 mx-auto mb-5 rounded-full" />
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8">
            {industries.map((item) => (
              <div
                key={item.id}
                className="bg-white/10 backdrop-blur rounded-2xl p-2 shadow-lg transform transition hover:scale-105 hover:bg-white/20"
              >
                <div className="mx-auto w-20 h-20 mb-4 rounded-full overflow-hidden border-4 border-white animate-spin-slow">
                  <img
                    src={item.imgSrc}
                    alt={item.title}
                    className="object-cover w-full h-full"
                  />
                </div>
                <h3 className="text-lg font-semibold text-white">
                  {item.title}
                </h3>
                <p className="text-sm text-white mb-3">{item.description}</p>
                <Link
                  to={item.path}
                  className="inline-block no-underline mt-2 px-4 py-2 bg-main1 text-white text-sm font-semibold rounded-full shadow hover:from-purple-500 hover:to-blue-500 hover:scale-105 transition-all duration-300 ease-in-out"
                >
                  Know More
                </Link>
              </div>
            ))}
          </div>
        </div>

        <style>{`
        .animate-spin-slow {
          animation: spin 12s linear infinite;
        }
        @keyframes spin {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
      `}</style>
      </div>
      {/*Our Case Study*/}

      <Casestudy />
      {/*Our Client*/}
      <OurClients />
      {/*Latest News*/}
      {/* all blog card */}
      <div>
        <AllBlogCard />
      </div>
    </>
  );
}

export default Home;
